import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'connectors'

export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }) =>
    callApi(`${apiBase}/connectors/${id}/actions/reload`, schema, {
      method: 'POST',
    })
